const baseURL = "/v1/PreLogin";

const service = {
  methods: {
    $obterFuncoes(params) {
      return this.$api().get(`${baseURL}/Funcoes`, params);
    },
    $obterLotacoes(params) {
      return this.$api().get(`${baseURL}/Lotacoes`, params);
    },
    $obterMunicipios(params) {
      return this.$api().get(`${baseURL}/Municipios`, params);
    },
    $obterMunicipiosSiepe(params) {
      return this.$api().get(`${baseURL}/MunicipiosSiepe`, params);
    },
    $obterCEP(params) {
      return this.$api().get(`${baseURL}/cep`, params);
    },
    $cadastrarCadastroPedagogico(body) {
      return this.$api().post(`${baseURL}/SolicitarAcesso`, body);
    },
  },
};

export default service;
